export default __webpack_public_path__ + "1a9ace386c2a7a156a3605a9b758cc3d.png";